/*
polyfills.ts
Copyright © 2026 Xerox Corporation. All Rights Reserved.

Copyright protection claimed includes all forms and matters of copyrightable material
and information now allowed by statutory or judicial law or hereinafter granted,
including without limitation, material generated from the software programs which
are displayed on the screen such as icons, screen display looks, etc.
*/

// Polyfill TextEncoder if not defined
if (typeof TextEncoder === 'undefined') {
    globalThis.TextEncoder = class TextEncoder {
      encoding: string;
  
      // Constructor should not accept arguments in line with TypeScript's definition
      constructor() {
        this.encoding = 'utf-8'; // Default encoding is 'utf-8'
      }
  
      encode(text: string): Uint8Array {
        // Encode the text using the global TextEncoder or a simple implementation
        const encoder = new globalThis.TextEncoder(); // No arguments in constructor
        return encoder.encode(text);
      }
  
      encodeInto(source: string, destination: Uint8Array): { read: number; written: number } {
        // Implementing a simplified version of encodeInto
        const encoded = new globalThis.TextEncoder().encode(source);
        const length = Math.min(encoded.length, destination.length);
        destination.set(encoded.slice(0, length), 0);
        return { read: source.length, written: length };
      }
    };
  }
  
  // Polyfill TextDecoder if not defined
  if (typeof TextDecoder === 'undefined') {
    globalThis.TextDecoder = class TextDecoder {
      encoding: string;
      fatal: boolean;
      ignoreBOM: boolean;
  
      // Constructor accepts encoding and options
      constructor(encoding: string = 'utf-8', options: TextDecoderOptions = {}) {
        this.encoding = encoding;
        this.fatal = options.fatal ?? false; // Default to false
        this.ignoreBOM = options.ignoreBOM ?? false; // Default to false
      }
  
      decode(input?: Uint8Array, options?: { stream?: boolean }): string {
        const decoder = new globalThis.TextDecoder(this.encoding, {
          fatal: this.fatal,
          ignoreBOM: this.ignoreBOM,
        });
        return decoder.decode(input, options);
      }
    };
  }
